// @ts-nocheck
import axios from "axios";
import useSWR, { SWRResponse } from "swr";
import { useToken } from "../context";
import { getApiBase } from "../utils/watchlist-api";

export interface IInstrumentInsight<ChartShape> {
  instrument: {
    id: number;
    name: string;
    symbol: string;
    type: string;
    closePrice: number;
    week52PriceChangePercent: number;
    ccy: {
      code: string;
      label: string;
    };
  };
  insight: {
    id: string;
    type: string;
    title: string;
    description: string;
    whyImportant: string;
    stats: { text: string }[];
  };
  chart: {
    title: string;
    data: ChartShape;
    preview?: boolean;
    mini?: boolean;
  };
}

export const useInstrumentInsight = <ChartShape>(
  instrumentId: number,
  insightId: string,
  watchlistId?: string
): SWRResponse<IInstrumentInsight<ChartShape>> => {
  const { token, environment } = useToken();
  const INSIGHTS_API_BASE = getApiBase(environment);

  const { data, ...query } = useSWR<IInstrumentInsight<ChartShape>>(
    ["instrument-insight", instrumentId, insightId, watchlistId],
    async () => {
      const url = watchlistId
        ? `${INSIGHTS_API_BASE}/watchlist/${watchlistId}/insight/insighttype/${insightId}?instrumentid=${instrumentId}`
        : `${INSIGHTS_API_BASE}/insight/insighttype/${insightId}?instrumentid=${instrumentId}`;
      const result = await axios.get<IInstrumentInsight<ChartShape>>(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return result?.data! as any;
    }
  );

  return {
    ...query,
    data,
  } as any;
};
